import {
  createLifestyle,
  updateLifestyle,
  getLifestyleById,
  getLifestyles,
} from "@/services/admin/lifestyle";

export const state = {
  lifestyles: [],
  currentLifestyle: {
    lang: "",
    brandId: "",
    title: "",
    description: "",
    images: [],
    metaKeyword: "",
    metaDescription: "",
    status: "",
  },
  formData: {
    lang: "",
    brandId: "",
    title: "",
    description: "",
    images: [],
    metaKeyword: "",
    metaDescription: "",
    status: "",
  },
  isUploading: false,
};

export const mutations = {
  SET_LIFESTYLES(state, lifestyles) {
    state.lifestyles = lifestyles;
  },
  SET_CURRENT_LIFESTYLE(state, lifestyle) {
    state.currentLifestyle = lifestyle;
    // Update formData dengan data lifestyle yang diterima
    state.formData = { ...lifestyle };
  },
  UPDATE_FORM_DATA(state, { field, value }) {
    state.formData = {
      ...state.formData,
      [field]: value,
    };
  },
  SET_UPLOADING_STATUS(state, status) {
    state.isUploading = status;
  },
  RESET_FORM(state) {
    state.formData = {
      lang: "",
      brandId: "",
      title: "",
      description: "",
      images: [],
      metaKeyword: "",
      metaDescription: "",
      status: "",
    };
  },
};

export const actions = {
  async fetchLifestyles({ commit }) {
    try {
      const response = await getLifestyles(1, 1000);
      commit("SET_LIFESTYLES", response.data.data);
    } catch (error) {
      console.error("Failed to fetch lifestyles:", error);
      throw error;
    }
  },

  async loadLifestyleById({ commit }, id) {
    try {
      const response = await getLifestyleById(id);
      const lifestyle = {
        lang: response.data.lang,
        brandId: response.data.brandId,
        title: response.data.title,
        description: response.data.description,
        images: response.data.images,
        metaKeyword: response.data.metaKeyword,
        metaDescription: response.data.metaDescription,
        status: response.data.status,
      };
      commit("SET_CURRENT_LIFESTYLE", lifestyle);
    } catch (error) {
      console.error("Failed to load lifestyle:", error);
      throw error;
    }
  },

  async saveLifestyle({ commit }, { id = null, formData }) {
    try {
      console.log("Saving lifestyle with data:", formData);

      // Gunakan formData yang dikirim dari component
      if (id) {
        await updateLifestyle(id, formData);
      } else {
        await createLifestyle(formData);
      }

      commit("RESET_FORM");
      return true;
    } catch (error) {
      console.error("Failed to save lifestyle:", error);
      throw error;
    }
  },

  updateFormField({ commit }, { field, value }) {
    commit("UPDATE_FORM_DATA", { field, value });
  },
};

export const getters = {
  isTitleDuplicate: (state) => (title) => {
    return state.lifestyles.some(
      (lifestyle) => lifestyle.title.toLowerCase() === title.toLowerCase()
    );
  },
};
